var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"100px"},attrs:{"id":"us-home"}},[_vm._v(" 准备授权... ")])}
var staticRenderFns = []

export { render, staticRenderFns }